import { gql } from '@apollo/client'
import PropTypes from '~/lib/propTypes'

export const userConsentFragment = gql`
  fragment userConsent on UserConsent {
    id
    type
    hasGivenConsent
  }
`

export const userConsentFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['MARKETING_EMAIL', 'USER_TESTING', 'MARKETING_PUSH_NOTIFICATION'])
    .isRequired,
  hasGivenConsent: PropTypes.bool.isRequired,
})
